export enum ModalId {
  UPDATE_CIG_NOTE_CONFIRMATION_DIALOG = "update-cig-note-confirmation-dialog",
  NAR_LETTER_MODAL = "nar-letter-modal",
  INSURANCE_ERROR_DIALOG = "insurance-error-dialog",
  IMAGE_VIEWER_MODAL = "image-viewer-modal",
  BO_VALUES_MODAL = "bo-values-modal",
  STATUS_UPDATE_MODAL = "status-update-modal",
  DOC_VIEWER_MODAL_WITH_TITLE = "doc-viewer-modal-with-title",
  DOC_VIEWER_MODAL = "doc-viewer-modal",
  DOC_VIEWER_WITH_SIDE_NAVIGATION = "doc-viewer-with-side-navigation",
  AUTH_INACCURACY_MODAL = "auth-inaccuracy-modal",
  FINAL_DOCUMENT_MODAL = "documents-modal",
  FORM_SELECTION_MODAL = "form-selection-modal",
  ANALYTICS_DATE_PICKER_MODAL = "analytics-date-picker-modal",
  API_RESPONSE_VIEWER_MODAL = "api-response-viewer-modal",
  TRIGGER_RPA_MODAL = "trigger-rpa-modal",
  TRIGGER_RPA_MODAL_NEW = "trigger-rpa-modal-new",
  COMMENT_RPA_MODAL_NEW = "comment-rpa-modal-new",
  STATUS_CHANGED_TO_HOLD_MODAL = "status-changed-to-hold-modal",
  HAPPY_FLOW_MODAL = "happy-flow-modal",
  CLINICAL_DATA_TABLE = "clinical-data-table",
  NAR_GRID_MODAL = "nar-grid-modal",
  TRIGGER_RPA_WITH_DOC_LIST_MODAL = "trigger-rpa-with-doc-list-modal",
  NAR_RPA_TRIGGER_MODAL = "nar-rpa-trigger-modal",
  IMAGE_VIEWER_WITH_BADGES_MODAL = "image-viewer-with-badges-modal",
  TOGGLE_SWITCH_CONFIRMATION_DIALOG = "toggle-switch-confirmation-dialog",
  ORDER_PROCESSING_INFO_MODAL = "order-processing-info-modal",
  DRAFT_SUBMISSION_MODAL = "draft-submission-modal",
  NAR_INGESTION_UPLOAD_MODAL = "nar-ingestion-upload-modal",
  NAR_INGESTION_RE_UPLOAD_MODAL = "nar-ingestion-re-upload-modal",
  MANAGE_ATTACHMENTS_MODAL = "manage-attachments-modal",
}
